<template>
  <div class="team-members__member">
    <div class="team-members__member-avatar">
      <q-avatar size="42px" color="primary" text-color="secondary" class="team-members__avatar">
        {{ member.name ? member.name.charAt(0).toUpperCase() : 'U' }}
      </q-avatar>
    </div>
    <div class="team-members__member-info">
      <p class="team-members__member-name">{{ member.name }}</p>
      <p class="team-members__member-email">{{ member.email }}</p>
    </div>
    <div class="team-members__member-role">
      <div class="team-members__member-actions">
        <div class="team-members__badge-wrapper">
          <q-badge :color="getBadgeColor(member.subClientRole)" text-color="secondary" :label="getDisplayRole(member.subClientRole)" class="team-members__badge" />
          <!-- Hidden debugging info -->
          <span style="display: none">Role: {{ getDisplayRole(member.subClientRole) }}</span>
          <div class="team-members__custom-tooltip">
            <div class="team-members__tooltip-arrow"></div>
            <div class="team-members__tooltip-content" v-if="member.subClientRole === 'manager' || isManagerRole(member.subClientRole)">
              <strong>Admin:</strong> full access to all features, billing, and team management
            </div>
            <div class="team-members__tooltip-content" v-else><strong>User:</strong> limited access to features</div>
          </div>
        </div>
        <q-btn v-if="canManage" flat round size="sm" color="grey-7" icon="settings" class="team-members__settings-btn" @click="openMemberMenu">
          <q-menu anchor="bottom right" self="top right" :offset="[0, 8]" class="team-members__dropdown-menu">
            <q-list class="team-members__dropdown-list">
              <q-item clickable v-close-popup @click="$emit('edit', member)" class="team-members__dropdown-item">
                <q-item-section>
                  <div class="row items-center">
                    <q-icon class="team-members__dropdown-icon q-mr-sm" name="o_edit" size="xs" />
                    <span>Edit</span>
                  </div>
                </q-item-section>
              </q-item>
              <q-item clickable v-close-popup @click="$emit('remove', member)" class="team-members__dropdown-item team-members__dropdown-item--negative">
                <q-item-section>
                  <div class="row items-center">
                    <q-icon class="team-members__dropdown-icon q-mr-sm" name="o_delete" size="xs" />
                    <span>Remove</span>
                  </div>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeamMemberItem',
  props: {
    member: {
      type: Object,
      required: true
    },
    canManage: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    isManagerRole(role) {
      // If no role, default to viewer
      if (!role) return false;

      // Convert to string explicitly to handle any type
      const roleStr = String(role).toLowerCase();

      // Check for admin role (not manager)
      return roleStr === 'admin' || roleStr.includes('admin');
    },
    getDisplayRole(role) {
      if (!role) return 'User';

      const roleStr = String(role).toLowerCase();

      // Simplified: manager and admin are both "Admin", everything else is "User"
      return roleStr === 'manager' || roleStr === 'admin' ? 'Admin' : 'User';
    },
    getBadgeColor(role) {
      if (!role) return 'grey-3';

      const roleStr = String(role).toLowerCase();

      // Simplified: manager and admin get primary color, everything else gets grey
      return roleStr === 'manager' || roleStr === 'admin' ? 'primary' : 'grey-3';
    },
    openMemberMenu() {
      // Method needed for the menu to work
    }
  }
};
</script>

<style lang="scss" scoped>
@import './team-members-styles.scss';
</style>
